// this file is generated by update_shopify_store_data.py at 2026-01-26 20:21:23.687279
var courses = [
    {
        "course_id": "AB3795BD-550F-EE11-997D-005056A74C71",
        "course_version": 2,
        "name": "Effective Communication: Individuals with Intellectual and Developmental Disabilities (IDD) in the Hospital Setting",
        "course_type": 1,
        "author_information": "Dr. Deborah Napolitano, Ph.D., BCBA-D, LBA",
        "description": "In this module, you will explore the varied approaches to communication people with intellectual and developmental disabilities may utilize and learn skills that foster effective communication with this population in the acute care setting.",
        "learning_objectives_html": "By the time you complete this course, you will be able to:\r\n<ul>\r\n    <li>Describe the variety of ways people with IDD communicate</li>\r\n    <li>Identify the components of communication</li>\r\n    <li>Incorporate&nbsp;best practices to foster effective communication&nbsp;in the acute care setting</li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "0C0B7090-D960-F011-99A0-005056A740BF",
                "course_category_name": "Golisano - Optimizing Care for Hospitalized Individuals with Intellectual and Developmental Disabilities - Courses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BDB7B074-BDD2-EB11-80E3-005056B142B5",
                "course_category_name": "Registered Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B92FC0B9-AF4B-F011-99A4-005056A77B46",
                "course_category_name": "CE Unlimited_BRIDGE (No DEI Courses)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FEB7B714-954B-46A4-89D6-628F916FB59B",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "53A09CBA-47F5-41DE-ABBC-397BDE607DA7",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "552455CB-0469-E811-B6FF-005056B10E33",
                "course_category_name": "CE Unlimited featuring Challenge Tracks",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B756B56E-BDD2-EB11-80E3-005056B142B5",
                "course_category_name": "LPN",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2F5C3339-BDD2-EB11-80E3-005056B142B5",
                "course_category_name": "Advance Practice Registered Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F0D93E9B-C313-F011-999F-005056A77B46",
                "course_category_name": "Golisano-CEUnlimited",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2E429D0C-4610-EE11-997D-005056A730AF",
                "course_category_name": "Golisano",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Golisano Institute for Developmental Disability Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center's Commission on Accreditation. Provider Number P0691",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 0.5,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];